import script from "./FilialiPage.vue?vue&type=script&setup=true&lang=js"
export * from "./FilialiPage.vue?vue&type=script&setup=true&lang=js"

import "./FilialiPage.vue?vue&type=style&index=0&id=b32851b0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b32851b0"]])

export default __exports__